import * as React from "react"
import {Typography} from '@mui/material'
import {IconSeeker, TooltipSeeker} from "@ui-seeker/core"
import {formatPercentage} from "@ui-seeker/utils"


export default function activeDiffColumn() {
	return {
		name: 'activeDiff',
		label: 'Active Diff  (%)',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { prevActiveUsers }) => <TooltipSeeker title={`Previous: ${prevActiveUsers || '-'}`}>
				<Typography sx={{ fontSize: '0.875rem', textAlign: 'center', color: !!value ? value > 0 ? 'green' : 'red' : 'default' }}>
					{ !!value && <IconSeeker icon={`arrow-${value > 0 ? 'up' : 'down'}`} sx={{ mr: 0.5 }} /> }
					{ value !== null && !!prevActiveUsers ? formatPercentage(value) : '-' }
				</Typography>
			</TooltipSeeker>
		}
	}
}